import React from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { useOrganizationAlias } from "@domain/currentProfile/hooks";
import { ImageVersions } from "@domain/media/dtos";
import { Track } from "@domain/organization/track/track";
import { getBanner } from "@utils/banner";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { NextButton } from "@ui/components/buttons/nextButton";
import { DraftRenderer } from "@ui/components/containers/draftRenderer";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Title } from "@ui/components/containers/title";
import { HatIcon } from "@ui/components/icons";
import { row, Row, stack } from "@ui/components/layout";
import { KebabMenu } from "@ui/components/menus/kebabMenu";
import { SimpleMenuContent } from "@ui/components/menus/simpleMenuContent";
import { useModalTools } from "@ui/modals/modalContext";
import { TrackEditorModal } from "./trackEditorModal";

interface TrackViewProps extends React.HTMLAttributes<HTMLDivElement> {
	track: Track;
	organizationId: string;
	onSelected: (track: Track) => void;
}
export const TrackView: React.FC<TrackViewProps> = ({ track, organizationId, onSelected, ...htmlProps }) => {
	const alias = useOrganizationAlias();
	const { trackService } = useServices();
	const { createModal } = useModalTools();

	return (
		<MainContainer {...htmlProps}>
			<StyledBackgroundImage
				image={track?.banner}
				defaultUrl={!track?.banner ? getBanner(track.id) : undefined}
				size={ImageVersions.MEDIUM}
			/>

			<Container>
				<TitleWrapper>
					<Title>{track.name}</Title>
					{alias && (
						<KebabMenu>
							<SimpleMenuContent
								onEdit={() =>
									createModal((close) => (
										<TrackEditorModal organizationId={organizationId} close={close} initialTrack={track} />
									))
								}
								onDelete={() => trackService.delete(track.id)}
							/>
						</KebabMenu>
					)}
				</TitleWrapper>
				<PrimaryMedium>
					<DraftRenderer content={track.description} />
				</PrimaryMedium>
				<Levels>
					{track.levels.map((lv, i) => (
						<Row gap={10} align="center" key={`${i}${lv.title}`}>
							<HatIcon />
							<PrimaryMedium>{lv.title}</PrimaryMedium>
						</Row>
					))}
				</Levels>
			</Container>
			<NextButton onClick={() => onSelected(track)} />
		</MainContainer>
	);
};

const MainContainer = styled(RoundedBlock)`
	position: relative;
	// border: none;
	overflow: hidden;
	heigth: auto;
	> button {
		position: absolute;

		right: 32px;
		bottom: 5px;
	}
`;

const Container = styled.div`
	${stack(30)};
	padding: 25px;
	position: relative;
`;

const StyledBackgroundImage = styled(BackgroundImage)`
	height: 175px;
`;

const TitleWrapper = styled.div`
	align-self: stretch;
	${row(10, "space-between", "center")};
`;

const Levels = styled.div`
	max-width: 300px;
	${stack(10)};

	svg path {
		fill: ${({ theme }) => theme.colors.textPrimary};
	}
`;
